/**
 * @packageDocumentation
 * @category Util
 */

/**
 * Move the item at `from` so it comes to rest at `to`.
 *
 * Returns the whole order rather than a patch, matching `moveColumn`: a partial
 * order is ambiguous the moment two items share a position.
 */
export const moveItem = <T>(items: readonly T[], from: number, to: number): T[] => {
  const next = [...items];
  if (from < 0 || from >= next.length || to < 0 || to >= next.length || from === to) return next;
  const [moved] = next.splice(from, 1);
  if (moved === undefined) return [...items];
  next.splice(to, 0, moved);
  return next;
};

/** The index a keyboard nudge lands on, or `null` when it would leave the list. */
export const nudgeIndex = (current: number, direction: -1 | 1, length: number): number | null => {
  const next = current + direction;
  return next < 0 || next >= length ? null : next;
};
